import { createRoute } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { OnboardingRentersFormPage } from './page.onboarding-renters-form'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.ONBOARDING_RENTERS_FORM,
  component: OnboardingRentersFormPage,
})
